<script setup>
import { computed } from "vue";

const props = defineProps({
  firstName: { type: String, default: "" },
  lastName: { type: String, default: "" },
  position: { type: String, default: null },
});

const fullName = computed(() =>
  [props.firstName, props.lastName].filter(Boolean).join(" ").trim()
);
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="font-semibold leading-tight text-foreground truncate">
      {{ fullName || "—" }}
    </div>
    <div
      v-if="position"
      class="text-sm text-muted-foreground leading-snug truncate"
    >
      {{ position }}
    </div>
  </div>
</template>
